import axios from 'axios';

import { API } from '@/config/constants';


export const extractOrderDocuments = async (files, additionalContext, idempotencyKey, requestConfig = {}) => {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  if (additionalContext) form.append('additional_context', additionalContext);

  const response = await axios.post(`${API}/extract-pdf-batch`, form, {
    ...requestConfig,
    headers: {
      ...requestConfig.headers,
      'Content-Type': 'multipart/form-data',
      'Idempotency-Key': idempotencyKey,
    },
  });
  return response.data;
};
